export default __webpack_public_path__ + "static/media/is_new.d4131793.svg";